import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz38 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel39'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel37'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Tic Tac Toe Puzzle</h1>
    
    <div class="text">
        <p><strong>Statement:</strong><br/>
            The game of Tic-Tac-Toe is being played between two players and it is in below
            state after six moves.</p>
        <p><img
                    src="https://media.geeksforgeeks.org/wp-content/cdn-uploads/tic_tac_toe.jpg" alt="p38ttt"
                    width="291" height="265" class="aligncenter size-full wp-image-23645"/></p>
        <p>Can you answer following questions?</p>
        <ol>
            <li>Who will win the game, O or X?</li>
            <li>Which was the sixth mark and at which position?</li>
        </ol>
        <p>Assume that both the players are intelligent enough.</p>
        <p>&nbsp;<br/>
            <div class="containers">
            <strong>Solution:</strong><br/>
            O will win the game. The sixth mark was X in square
            9.<br/>
            <br/>
            &nbsp;<br/>
            </div>
            <strong>Explanation:</strong><br/>
           The 7th mark must be placed in square 5 which is the
            win situation for both X and O. Hence, the 6th mark must be placed in a line already containing two of the
            opponents marks. There are two such possibilities – the 6th mark would have been either O in square 7 or X
            in square 9.</p>
        
        <p>As we know both the players are intelligent enough, the 6th mark could not be O in square 7. Instead, he
            would have placed O in square 5 and would have won.</p>
        <p>Hence, the sixth mark must be X placed in square 9. And the seventh mark will be O. Thus O will win the
            game.<br/>
            <br/>
            &nbsp;<br/>
        
        </p>
        
            </div>
            
</article>
        </div>

    )
}

export default Puz38
